export enum ActionButtonModeEnum {
    none = "none",
    setToReview = "setToReview",
    contentEditorApprove = "contentEditorApprove",
    update = "update",
    emailToAuthor = "emailToAuthor",
}